import * as utils from '../utils';
import * as launcher from 'chrome-launcher';
import * as desiredCapabilitiesBuilder from '../commons/testimDesiredCapabilitiesBuilder';
import { CDPTestRunner } from '../cdpTestRunner';
import { registerExitHook } from '../processHandler';
import type { InitOptions } from './webdriver';

export type LauncherDriverType = LauncherDriver;
class LauncherDriver {
    _isAlive = false;
    cdpTestRunner = new CDPTestRunner();
    chrome: undefined | launcher.LaunchedChrome;
    constructor(private readonly sessionId: string) {
    }

    async init(options: InitOptions) {
        const { browserOptions, testName, testRunConfig, gridInfo, customExtensionLocalLocation, executionId, testResultId, printFinalCaps, mode } = options;
        const capabilities = desiredCapabilitiesBuilder.buildSeleniumOptions({
            browserOptions, testName, testRunConfig, gridInfo, customExtensionLocalLocation, executionId, testResultId, printFinalCaps, mode,
        });
        const chromeFlags = [
            // @ts-expect-error This seems to be broken due to wdio7 migration
            ...(capabilities.desiredCapabilities?.chromeOptions.args ?? []),
            ...(capabilities.capabilities?.alwaysMatch?.['goog:chromeOptions']?.args ?? []),
            ...launcher.Launcher.defaultFlags().filter((flag) => flag !== '--disable-extensions'),
        ];
        this.chrome = await launcher.launch({ chromeFlags, startingUrl: undefined, ignoreDefaultFlags: true });
        this.chrome.process.once('exit', () => { this._isAlive = false; });
        this.chrome.process.once('close', () => { this._isAlive = false; });
        this._isAlive = true;
        const webSocketDebuggerUrl = await utils.getCdpAddressForHost(`localhost:${this.chrome.port}`);
        await this.cdpTestRunner.initSession(webSocketDebuggerUrl);

        registerExitHook(() => this.chrome!.kill());
    }

    isAlive() {
        return this._isAlive;
    }

    start() {
        // noop
    }

    async stop() {
        await this.cdpTestRunner.stopSession();
        if (this.chrome) {
            await this.chrome.kill();
        }
        this._isAlive = false;
    }

    getSessionId() {
        return this.sessionId;
    }
}

export class ChromeLauncherTestPlayer {
    sessionId = utils.guid();
    driver = new LauncherDriver(this.sessionId);
    constructor(public readonly id: number) {
    }

    async onDone() {
        return this.driver.stop();
    }

    getSessionId() {
        return this.sessionId;
    }
}
